export default function CsharpMultipleVariables() {
  return (
    <h2>Csharp Multiple Variables</h2>
  );
}
